import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import { axiosAuth } from '../../../../api';
import Swal from 'sweetalert2';
import Select from 'react-select';

function ModalDetailPcpSewa({
    rowSelected,
    showDetailPcpSewa,
    setShowDetailPcpSewa,
    pcpData,
    retrievePCPDetail
}) {

    const { userInfo, accessToken } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [listCategory, setListCategory] = useState([]);

    const retrieveCategoryProduct = () => {

        axiosAuth.get(`/api/pcp/categories`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,

                },

            })
            .then(res => {

                setListCategory(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveCategoryProduct();
    }, [accessToken]);

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);


    const handleClose = () => {
        setShowDetailPcpSewa(false);
    };

    const defaultValue = {
        productName: rowSelected?.productName || "",
        productDesc: rowSelected?.productDesc || "",
        categoryId: rowSelected?.category?.id || "",
    };

    const [duration, setDuration] = useState('');
    const [buyingPrice, setBuyingPrice] = useState(rowSelected?.buyingPrice || '');
    const [sellingPrice, setSellingPrice] = useState(rowSelected?.buyingPrice || '');
    const [qty, setQty] = useState('');

    const categoryOptions = useMemo(() => {
        return listCategory.map(category => ({
            value: category.id,
            label: category.categoryName,
        }));
    }, [listCategory]);

    const handleSelectCategory = (selectedOption, setFieldValue) => {
        setFieldValue('categoryId', selectedOption ? selectedOption.value : null);
    };

    const overHead = parseFloat(sellingPrice) * parseFloat(duration) * parseFloat(qty) * 0.03 || 0;

    const [edlCost, setEdlCost] = useState(0);
    const [financialCostPercentage, setFinancialCostPercentage] = useState(10);
    const financialCostAmount = buyingPrice * qty * (financialCostPercentage / 100) || 0;
    const [otherFinancialCost, setOtherFinancialCost] = useState(0);
    const [otherAllowance, setOtherAllowance] = useState(0);

    useEffect(() => {
        setDuration((rowSelected?.duration / 30) || '');
        setBuyingPrice(rowSelected?.buyingPrice || '');
        setSellingPrice(rowSelected?.sellingPrice || '');
        setQty(rowSelected?.quantity || '');
        setEdlCost(rowSelected?.edl || '');
        setFinancialCostPercentage(rowSelected?.financialCostPercentage || '');
        setOtherFinancialCost(rowSelected?.otherFinancialCost || '');
        setOtherAllowance(rowSelected?.otherAllowance || 0);
    }, [rowSelected]);

    function handleChangeBuyingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setBuyingPrice(numericValue);
    }

    function handleChangeSellingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setSellingPrice(numericValue);
    }

    function handleChangeEDL(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setEdlCost(numericValue);
    }

    function handleChangeOtherFinanceCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setOtherFinancialCost(numericValue);
    }

    function handleChangeOtherAllowance(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setOtherAllowance(numericValue);
    }

    const calculatedSubTotal = parseFloat(sellingPrice) * parseInt(qty, 10) * parseInt(duration, 10);

    const calculatedPurchaseTotal = parseFloat(buyingPrice) * parseInt(qty, 10);

    const grossMargin = parseFloat(calculatedSubTotal) - parseFloat(calculatedPurchaseTotal) || 0;

    const subTotalCost = (overHead || 0) + (edlCost || 0) + (financialCostAmount || 0) + (otherFinancialCost || 0) + (otherAllowance || 0);

    const nettMargin = parseFloat(grossMargin) - parseFloat(subTotalCost) || 0;

    const nettPercentage = parseInt(nettMargin) / parseInt(calculatedSubTotal) * 100;

    const marginTotal = ((parseFloat(nettMargin) / parseFloat(calculatedSubTotal))) * 100;

    const handleSubmitEditPCPSewa = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const dataPCPDetail = {
            username: userInfo?.username,
            subtotal: calculatedSubTotal,
            margin: marginTotal.toFixed(2) || 0,
            duration: parseInt(duration * 30) || 0,
            buyingPrice: buyingPrice || 0,
            sellingPrice: sellingPrice || 0,
            quantity: parseInt(qty) || 0,
            pcpId: pcpData?.id,
            overhead: overHead,
            edl: edlCost || 0,
            financialCostPercentage: parseInt(financialCostPercentage),
            financialCost: financialCostAmount,
            otherFinancialCost: otherFinancialCost || 0,
            otherAllowance: otherAllowance || 0,
            nett: nettMargin,
            ...values
        }

        try {

            const response = await axiosAuth.put(`/api/pcp/sewa/details/${rowSelected?.id}`, dataPCPDetail, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Produk',
                showConfirmButton: true,
            });

            retrievePCPDetail();

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengupdate Produk',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }

    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputQty: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputNettmargin: {
            color: nettMargin <= 300000
                ? 'red'
                : theme === 'light'
                    ? '#FFFFFF'
                    : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputBodyGroup: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            maxHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            width: '100%', // make sure it stretches
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (
        <Modal
            show={showDetailPcpSewa}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='xl'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Formik
                initialValues={defaultValue}
                enableReinitialize={true}
                onSubmit={handleSubmitEditPCPSewa}
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    setFieldValue
                }) => (
                    <>
                        <Modal.Header
                            closeButton={
                                rowSelected?.productName != values?.productName ||
                                    rowSelected?.productDesc != values?.productDesc ||
                                    (rowSelected?.duration / 30) != duration ||
                                    rowSelected?.buyingPrice != buyingPrice ||
                                    rowSelected?.sellingPrice != sellingPrice ||
                                    rowSelected?.edl != edlCost ||
                                    rowSelected?.financialCostPercentage != financialCostPercentage ||
                                    rowSelected?.otherFinancialCost != otherFinancialCost ||
                                    rowSelected?.otherAllowance != otherAllowance ||
                                    rowSelected?.nett != nettMargin ||
                                    rowSelected?.subtotal != calculatedSubTotal
                                    ?
                                    false
                                    :
                                    true
                            }
                        >
                            <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                                Detail PCP
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col xs={12} lg={5}>
                                        <Row>
                                            <Col xs={12} lg={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor='productName'>Nama Produk*</Form.Label>
                                                    <Form.Control
                                                        id='productName'
                                                        type='text'
                                                        value={values.productName}
                                                        onChange={handleChange("productName")}
                                                        required
                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                        placeholder='Nama Produk'
                                                        style={formStyles.input}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor='duration'>Durasi Sewa (Bulan)*</Form.Label>
                                                    <Form.Control
                                                        id='duration'
                                                        type='number'
                                                        onChange={(e) => setDuration(e.target.value)}
                                                        value={duration}
                                                        required
                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                        placeholder='Durasi Sewa'
                                                        style={formStyles.input}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor='category'>Jenis Produk*</Form.Label>
                                                    <Select
                                                        id='category'
                                                        options={categoryOptions}
                                                        required
                                                        value={categoryOptions.find(option => option.value === values.categoryId) || null}
                                                        onChange={(selectedOption) => handleSelectCategory(selectedOption, setFieldValue)}
                                                        styles={selectStyles}
                                                        placeholder='Pilih Jenis Produk'
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor='spec'>Spesifikasi</Form.Label>
                                                    <Form.Control
                                                        id='spec'
                                                        as='textarea'
                                                        rows={4}
                                                        value={values.productDesc}
                                                        onChange={handleChange("productDesc")}
                                                        required
                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                        style={formStyles.input}
                                                        placeholder='Spesifikasi'
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor="buyingPrice">
                                                        Harga Beli*
                                                    </Form.Label>
                                                    <Form.Control
                                                        id="buyingPrice"
                                                        type="text"
                                                        onChange={handleChangeBuyingPrice}
                                                        value={`Rp ${buyingPrice ? buyingPrice.toLocaleString('id-ID') : ''}`}
                                                        required
                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                        placeholder="Harga Beli"
                                                        style={formStyles.input}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor='sellingPrice'>Harga Sewa Perbulan*</Form.Label>
                                                    <Form.Control
                                                        id='sellingPrice'
                                                        type='text'
                                                        onChange={handleChangeSellingPrice}
                                                        value={`Rp ${sellingPrice ? sellingPrice.toLocaleString('id-ID') : ''}`}
                                                        required
                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                        placeholder='Harga Sewa Perbulan'
                                                        style={formStyles.input}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={formStyles.label} htmlFor='qty'>Qty*</Form.Label>
                                                    <Form.Control
                                                        id='qty'
                                                        type='text'
                                                        onChange={(e) => setQty(e.target.value)}
                                                        value={qty}
                                                        required
                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                        style={formStyles.input}
                                                        placeholder='Jumlah'
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={1}></Col>
                                    <Col xs={12} lg={6}>
                                        <Row>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='overHead'>Over Head (3%)</Form.Label>
                                                <Form.Control
                                                    id='overHead'
                                                    type='text'
                                                    className='mb-3'
                                                    value={numberFormat(overHead) || 0}
                                                    readOnly
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='edlCost'>External Direct Labor Cost</Form.Label>
                                                <Form.Control
                                                    id='edlCost'
                                                    type='text'
                                                    className='mb-3'
                                                    onChange={handleChangeEDL}
                                                    value={`Rp ${edlCost ? edlCost.toLocaleString('id-ID') : '0,00'}`}
                                                    required
                                                    readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='fcPercentage'>Financial Cost %</Form.Label>
                                                <Form.Control
                                                    id='fcPercentage'
                                                    type='number'
                                                    className='mb-3'
                                                    value={financialCostPercentage || ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            setFinancialCostPercentage(value);
                                                        }
                                                    }}
                                                    required
                                                    readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='financeCost'>Financial Cost Amount</Form.Label>
                                                <Form.Control
                                                    id='financeCost'
                                                    type='text'
                                                    className='mb-3'
                                                    value={numberFormat(financialCostAmount)}
                                                    readOnly
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='otherFinancialCost'>Other Financial Cost</Form.Label>
                                                <Form.Control
                                                    id='otherFinancialCost'
                                                    type='text'
                                                    className='mb-3'
                                                    onChange={handleChangeOtherFinanceCost}
                                                    value={`Rp ${otherFinancialCost ? otherFinancialCost.toLocaleString('id-ID') : '0,00'}`}
                                                    required
                                                    readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='otherAllow'>Other Allowance</Form.Label>
                                                <Form.Control
                                                    id='otherAllow'
                                                    type='text'
                                                    className='mb-3'
                                                    onChange={handleChangeOtherAllowance}
                                                    value={`Rp ${otherAllowance ? otherAllowance.toLocaleString('id-ID') : '0,00'}`}
                                                    required
                                                    readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='subTotalCost'>Sub Total Cost</Form.Label>
                                                <Form.Control
                                                    id='subTotalCost'
                                                    type='text'
                                                    className='mb-3'
                                                    value={numberFormat(subTotalCost) || 0}
                                                    readOnly
                                                    style={formStyles.input}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label style={formStyles.label} htmlFor='nettMargin'>Nett Margin</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        id='nettMargin'
                                                        type='text'
                                                        className='mb-3'
                                                        value={numberFormat(nettMargin) || '0,00'}
                                                        readOnly
                                                        style={formStyles.inputNettmargin}
                                                    />
                                                    <InputGroup.Text
                                                        id="basic-addon1"
                                                        style={formStyles.inputBodyGroup}
                                                    >
                                                        {nettPercentage.toFixed(2) + '%'}
                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                {userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ?
                                    <div className="d-grid gap-2 mt-4 mb-2">
                                        {isSubmitting ? (
                                            <Button
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                variant='btn'
                                                disabled
                                            >
                                                <Spinner
                                                    animation="border"
                                                    size='sm'
                                                />
                                            </Button>
                                        ) : (
                                            <Button
                                                type="submit"
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                variant='btn'
                                                disabled={disabled}
                                            >
                                                Simpan
                                            </Button>
                                        )}
                                    </div>
                                    :
                                    <></>
                                }
                            </Form>
                        </Modal.Body>
                    </>
                )}
            </Formik>
        </Modal >
    )
}

export default ModalDetailPcpSewa
